import ArchiveConfirmationForm from "@/components/DatasetEditor/Header/ArchiveButton/ArchiveConfirmationForm";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";
import { useIsWorkspaceAdmin } from "@/hooks/workspaces";
import { useDeleteWorkspace } from "@/queries";
import { Workspace } from "@/types/workspaces";
import { TrashIcon } from "@heroicons/react/outline";

import { useState } from "react";

const DeleteWorkspace = ({ workspace }: { workspace: Workspace }) => {
  const [open, setOpen] = useState(false);
  const deleteWorkspace = useDeleteWorkspace();
  const isWorkspaceAdmin = useIsWorkspaceAdmin();
  const onSuccess = () => {
    deleteWorkspace.mutate(workspace.id);
  };
  if (workspace.is_default) return null;
  if (!isWorkspaceAdmin) return null;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="destructiveLink" onClick={() => setOpen(true)}>
          <TrashIcon className="h-4 w-auto pr-2" aria-hidden="true" />
          Delete
        </Button>
      </DialogTrigger>
      <DialogContent>
        <ArchiveConfirmationForm
          name={workspace.name}
          setOpen={setOpen}
          onSuccess={onSuccess}
        />
      </DialogContent>
    </Dialog>
  );
};

export default DeleteWorkspace;
